export default function spaceFormat(space: number[] | undefined): string {
    if (space && space.length) {
        let num = '';

        for (let i = 0; i < space?.length; i++) {
            num += `${space[i]}px `;
        }

        return num;
    }

    return '';
};